import { loadDevMessages, loadErrorMessages } from '@apollo/client/dev';
import * as Sentry from '@sentry/react';

import { initSessionRecorder } from '@spotify-internal/confidence-session-replay';
import {
  getSessionId,
  isTestEnvironment,
} from '@spotify/confidence-core-react';

// eslint-disable-next-line @backstage/no-relative-monorepo-imports
import buildCommit from '../../../build-commit.json';
import { confidenceApi } from './apis/Apis';
import { loadTrackJS } from './apis/ConsentManagement';
import { setupConfidenceTrackers } from './confidenceTrackers';
import { setupWebVitals } from './metrics';

const IS_PRODUCTION = process.env.NODE_ENV === 'production';
const IS_E2E_TEST = isTestEnvironment();
const IS_LOCALHOST = window?.location.hostname.startsWith('localhost');

if (IS_PRODUCTION && !IS_E2E_TEST && !IS_LOCALHOST) {
  loadTrackJS();
}

if (IS_PRODUCTION && !IS_E2E_TEST) {
  setupWebVitals();
  setupConfidenceTrackers(confidenceApi);

  const visitorId =
    document.cookie
      .split(/;\s*/g)
      .find(c => c.startsWith('cnfdVisitorId='))
      ?.split('=')[1] ?? undefined;
  initSessionRecorder({
    clientSecret: 'NiAgIVmkjVSTNI5k8mpsgs3EeFqkacrA',
    context: {
      visitor_id: visitorId,
      session_id: getSessionId(),
      origin: window.location.origin,
      path: window.location.pathname,
    },
    blockSelectors: ['[data-csr-block]'],
    maskSelectors: ['[data-csr-mask]'],
    captureConsoleLogs: { levels: ['warn', 'error'] },
    captureNetworkRequests: true,
  });
}

Sentry.init({
  dsn: 'https://e429b0654e22474f81655df4103dd4bb@o22381.ingest.sentry.io/4504633286131712',
  release: `confidence@${buildCommit.commitHash}`,
  tracesSampleRate: 0.0025,
  enabled: IS_PRODUCTION && !IS_LOCALHOST,
  environment: process.env.NODE_ENV,
});

if (!IS_PRODUCTION) {
  // show apollo errors in dev
  loadDevMessages();
  loadErrorMessages();

  // enable MSW
  try {
    if (window?.localStorage.getItem('use-msw') === 'true') {
      import('./mocks/browser').then(({ worker }) => {
        worker.start();
      });
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
}
